import wixWindow from 'wix-window';
import wixLocation from 'wix-location';



export function button1_click_1(event) {
	if ($w('#input1').value === 'התחל') {
			wixLocation.to('https://www.zoomescape.co.il/mainschl');
			}
	else {
		wixWindow.openLightbox("no");
	}		
}